$(document).ready(function() {  
  
  featuredCollectionSlider();
  textWithSlider(); 
  gallerySlider();

  faqTabs();
  faqScroll();

  // Show the first tab by default
  // $('.tabs-stage .tabs-info-wrapper').hide();
  // $('.tabs-stage .tabs-info-wrapper:first').show();
  // $('.tabs-nav li:first').addClass('tab-active');
  
  //  Change tab class and display content
  // $('.tabs-nav a').on('click', function(event){
  //   event.preventDefault();
  //   $('.tabs-nav li').removeClass('tab-active');
  //   $(this).parent().addClass('tab-active');
  //   $('.tabs-stage .tabs-info-wrapper').hide();
  //   $($(this).attr('href')).show();
  // });

  // When a tab link is clicked
    $('.tabs-nav a').on('click', function(event) {
      event.preventDefault(); // Prevent default link behavior
    
      // Find the closest .tabs container
      var $tabContainer = $(this).closest('.tabs');
    
      // Remove active class from all tabs in this container
      $tabContainer.find('.tabs-nav li').removeClass('tab-active');
      $(this).parent().addClass('tab-active'); // Add active class to the clicked tab
    
      // Hide all tab contents in this container
      $tabContainer.find('.tabs-stage .tabs-info-wrapper').hide();
    
      // Show the corresponding tab content for the clicked tab
      var target = $(this).attr('href'); // Get the target content via href attribute
      $tabContainer.find(target).show(); // Show the selected tab content within this container
    });

 
  

  

  $(document).on("click",".pro-soldout-btn",function(e){
    e.preventDefault();
    //$("#shopify-block-pre_order_restock_notifier_back_in_stock_notifier_DKGbU8").click();
    $("#shopify-block-pre_order_restock_notifier_back_in_stock_notifier_DKGbU8 .ct_button").trigger('click');
  });

});

function featuredCollectionSlider() { 
  if(!document.querySelector('.featured-collection-wrapper .featured-collection-slider')) return;
  
  let desktopSliderPerView = Number(document.querySelector('.featured-collection-slider').dataset.sliderPerShow || 4);
  var swiper = new Swiper(".featured-collection-slider", {    
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
      allowTouchMove: true,
      keyboard: {
        enabled: true,
      },
    },
      breakpoints: {  
        10: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: desktopSliderPerView,
          spaceBetween: 30,
        },
      },
  });    
}


function textWithSlider() { 
  if(!document.querySelector('.text-with-slider-wrapper .textWithSlider')) return;
    
    var swiper = new Swiper(".textWithSliderText", {
      effect: "fade",  
      loop: true,
      watchSlidesProgress: true,
      allowTouchMove: true,
      draggable: true,
      keyboard: {
        enabled: true,
      },
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    var swiper2 = new Swiper(".textWithSlider", {
      effect: "fade", 
      loop: true,   
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: swiper,
      },
      draggable: true,
      keyboard: {
        enabled: true,
      },
      mousewheel: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });     
}

function faqScroll() { 
  if(!document.querySelector('.faqScroll')) return;
    var swiper = new Swiper(".faqScroll", {
      slidesPerView: "auto",
      spaceBetween: 45, 
      draggable: true,
      keyboard: {
        enabled: true,
      },
    });    
}

function gallerySlider() { 
  if(!document.querySelector('.gallery-slider-wrapper .gallery-slider-list')) return;  
  var swiper = new Swiper(".gallery-slider-list", {
    spaceBetween: 20,         
    loop: true,
    draggable: true,
    keyboard: {
      enabled: true,
    },
    mousewheel: true,
    // scrollbar: {
    //   el: ".swiper-scrollbar",
    //   hide: false,
    //   draggable: true,
    // },
    // autoplay: {
    //   delay: 1,
    // },   
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView:'auto',
    allowTouchMove: true,
    disableOnInteraction: true
  });    
}

// function gallerySlider() { 
//   if(!document.querySelector('.gallery-slider-wrapper .gallery-slider-list')) return;  
//   var swiper = new Swiper(".gallery-slider-list", {    
//     scrollbar: {
//       el: ".swiper-scrollbar",
//       hide: false,
//       draggable: true,
//     },
//     slidesPerView: "auto",
//     spaceBetween: 20,          
//     initialSlide: 0,
//     breakpoints: {  
//         10: {
//           slidesPerView: 2,
//           spaceBetween: 15,          
//         },       
//         750: {
//           slidesPerView: "auto",
//           spaceBetween: 20,
//         },        
//         1199: {
//           slidesPerView: "auto",
//           spaceBetween: 20,          
//         },
//       },
//   });    
// }


// faq tabs -- start JS
function faqTabs() {
  let tabsTitle = document.querySelectorAll("[data-faq_content]");
  tabsTitle.forEach(item => {
    item.addEventListener("click", () => {
      let tabsData = item.getAttribute('data-faq_content');
      let tabsButtons = document.querySelectorAll("[data-faq_content]");
      tabsButtons.forEach(b => {
        if(b.getAttribute('data-faq_content') == tabsData){
          if(b.classList.contains('is_open')){
            b.classList.remove("is_open");    
          }else{
            b.classList.add("is_open");
          }
        }else{
          b.classList.remove("is_open");
        }
      });
    }); // click event END
  });
}

var navigation = $(".faq-scroll-tab");    
navigation.on("click", "a", function (event) {
  event.preventDefault(); //prevents previous event
  $(".faq-scroll-tab a").removeClass("active")
  $(this).addClass("active");
  smoothScroll($(this.hash));
});
  
function smoothScroll(target) {
  console.log(target);
  var header_hight = (document.querySelector('sticky-header').offsetHeight + 10) || 150;
    $("body,html").animate(
        {
            scrollTop: target.offset().top - header_hight
        },
        300
    );
}

if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
     const featuredCollectionSliderSection = event.target.closest('.featured-collection-wrapper') || null;
      if(featuredCollectionSliderSection){
        featuredCollectionSlider();
      }
      
      const textWithSliderWrapper = event.target.closest('.text-with-slider-wrapper') || null;
      if(textWithSliderWrapper){
        textWithSlider();
      }


      const gallerySliderWrapper = event.target.closest('.text-with-slider-wrapper') || null;
      if(gallerySliderWrapper){
        gallerySlider();
      }

      
    });
  });
}

  $(document).on("click",".newslatter-popup-wrapper .exit",function() {
      $(".newslatter-popup-wrapper").removeClass("open");
      setCookie("sub_popup_cookie", "News_letter_popup", 24); // 24 hours
  });

  function setCookie(cname, cvalue, exhours) {
      var d = new Date();
      d.setTime(d.getTime() + (exhours * 60 * 60 * 1000)); // Expiry time in hours
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }


  // Check if the cookie exists
  function checkCookie() {
      var cookieValue = getCookie("sub_popup_cookie");
      if (cookieValue != "") {
          // console.log("Cookie value is: " + cookieValue);
        $(".newslatter-popup-wrapper").removeClass("open")
      } else {
          // console.log("Cookie expired");
        $(".newslatter-popup-wrapper").addClass("open")
      }
  }
  
  // Function to get a cookie value
  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  // Check the cookie when the page loads
  checkCookie();
 
$("#menu-drawer .close-nav").click(function(){
  $(".header__icon--menu").trigger("click");
});

const appHeight = () => {
   const doc = document.documentElement
   doc.style.setProperty("--vh", `${window.innerHeight}px`)
  }
  window.addEventListener("resize", appHeight)
appHeight();


$(document).on('scroll',function(){
  var scrollTop = (document.querySelector('sticky-header').offsetHeight + 40) || 0;
  const accTitles_all = document.querySelectorAll('.faq-accordian h3.accordion-heading[acc_heading]') || null;
  if (accTitles_all){
    accTitles_all.forEach(function(item) {
     const item_offsets = item.getBoundingClientRect();
      // console.log(item);
      if(item_offsets.top < scrollTop){
          $('.faq-scroll-tab a[faq_title]').removeClass('active');
          document.querySelector('[faq_title="'+item.getAttribute('acc_heading')+'"]').classList.add('active');
      }
    });
  }
});

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
 item.addEventListener("mouseover", () => {
  item.setAttribute("open", true);
   item.querySelector("ul").addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
   item.addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
 });
});

$(document).on('click', '.upsell-remove-button', function(){
  let currentTab = $(this).attr('data-name');
     $('.upcell-product[data-title="' + currentTab + '"]').hide();  
});

//var $slider = $('.cust_slider .swiper-wrapper .swiper-slide.cust_img').attr('card_img');
var $slider = $('.cust_slider .swiper-wrapper .swiper-slide.cust_img').attr('card_img');
if ($slider > 1) {
  
  var swiperFeatureImg = new Swiper(".cust_slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: true,
    // autoplay: {
    //   delay: 3000,-pr
    //   disableOnInteraction: false,
    // },
    freeMode: false,
    mousewheel: false,
    loop: true,
    navigation: {
      nextEl: ".product-card-wrapper .swiper-button-next",
      prevEl: ".product-card-wrapper .swiper-button-prev",
    }
  });
} else {
  // Hide navigation buttons if there's only one image
  $(".swiper-button-next, .swiper-button-prev").hide();
}


  var swiperFeatureImg = new Swiper(".cart-collection-swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: true,
    loop: true,
    // autoplay: {
    //   delay: 3000,-pr
    //   disableOnInteraction: false,
    // },
    mousewheel: false,
    freeMode: false,
       navigation: {
      nextEl: ".collection-card-wrappers .swiper-button-next",
      prevEl: ".collection-card-wrappers .swiper-button-prev",
    }
  });
